<template>
  <div class="backStack-issue-wrap">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <UserInfos ref="userInfos" :infos="userInfo"></UserInfos>
    <div class="backStack-issue-footer-wrap">
      <div class="read-wrap">
        <a-checkbox v-model="isRead" @change="readChange"></a-checkbox>
        <span class="text">我已阅读并同意《需求发布规则》</span>
      </div>
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="toAudit">提交审核</a-button>
        <span class="text"
          >温馨提示：需求成果提交后，将由相关人员审核后，方可发布！</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import UserInfos from '../../components/userInfos/index.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formRules, formRows, userInfo } from './configs/formOptions.js'
import { addDemandIssue } from '@/api/demandIssue.js'
import { getUserInfo } from '@/api/demandInfos.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: true,
      userInfo, // 数据
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {}, // 表单的默认值
      isRead: false
    }
  },
  components: {
    From,
    UserInfos
  },
  created() {
    this.getUserInfo() // 获取用户信息
  },
  methods: {
    // 处理用户信息
    async getUserInfo() {
      const userInfo = await getUserInfo()
      this.dealInfo('userInfo', userInfo.data)
    },
    // 处理静态信息
    dealInfo(type, result) {
      if (!this[type]) return
      this[type].forEach(item => {
        const { key } = item
        const v = result[key]
        item.value = v || '-'
      })
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 参数处理
    beforeRequest() {
      const { inputValue, ...formValue } = this.$refs.formRef.formModel

      const userInfo = this.$refs.userInfos.model
      const params = { ...formValue, ...userInfo }
      if (inputValue) {
        params.priceRange = inputValue
      }
      return params
    },
    async toAudit() {
      const v = this.$refs.formRef.validatedForm(undefined, function(
        formModal
      ) {
        if (formModal.inputValue === undefined && formModal.priceRange !== -1) {
          this.$apiStatusHandler(99, '预算金额不能为空')
          return false
        }
        return true
      })
      if (!v) return
      if (!this.isRead) {
        // 编辑状态下不检查这个勾选
        return this.$apiStatusHandler(1, '请勾选《需求发布规则》')
      }
      const params = this.beforeRequest()
      const { code, msg } = await addDemandIssue(params)
      this.$router.push({ name: 'demandInfos', query: { key: 'demandInfos' } })
      this.$apiStatusHandler(code, msg)
    }
  }
}
</script>
